require('/cloud/source_code/node_modules/_@cainiaofe_cn-error-feedback@1.0.1@@cainiaofe/cn-error-feedback/es/style.js');
import CnErrorFeedback from "./view";
export default CnErrorFeedback;
export { CnErrorFeedback };
export * from "./const";
export * from "./type";